import { FormaPagamento } from "resources/enums/tenant";

export function mapFormaPagamentoToLabel(
  formaPagamento?: FormaPagamento,
  defaultValue: string = "--"
): string {
  if (!formaPagamento) return defaultValue;
  const map = {
    [FormaPagamento.BoletoBancario]: "Boleto",
    [FormaPagamento.Cheque]: "Cheque",
    [FormaPagamento.CartaoCredito]: "Cartão de Crédito",
    [FormaPagamento.CartaoDebito]: "Cartão de Débito",
    [FormaPagamento.Transferencia]: "Transferência",
    [FormaPagamento.Pix]: "Pix",
    [FormaPagamento.Dinheiro]: "Dinheiro",
    [FormaPagamento.DebitoEmConta]: "Débito em conta",
  };

  return map[formaPagamento];
}
